// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__155Bz","content":"Consent_content__1hr85","footer":"Consent_footer__2hcTx"};